import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, change } from 'redux-form';
import first from 'lodash/first';
import partial from 'lodash/partial';
import idx from 'idx';
import isEmail from 'sane-email-validation';
import { sendContact, toggleChat } from 'help/ducks/contact';
import Contact from 'marketing/components/consultation_chinese';
import {
  HELP_FORM, INVALID_EMAIL, NAME_REQUIRED, MESSAGE_REQUIRED,
  PHONE_REQUIRED, CATEGORY_REQUIRED, timeOptions,
} from 'help/constants';


export function validate(values) {
  const errors = {};

  if (!values.full_name) {
    errors.full_name = '请输入您的姓名。';
  }

  if (!values.email || !isEmail(values.email)) {
    errors.email = '请输入一个有效的电子邮箱地址。';
  }

  if (!values.via_email && !values.phone_number) {
    errors.phone_number = '请输入一个我们能联系到您的电话号码。';
  }

  if (!values.message) {
    errors.message = '请用一小段话告诉我们如何能帮助到您。';
  }

  return errors;
}

export function mapStateToProps(state) {
  const { help: { contact }, user } = state;
  const initialValues = {
    best_time_to_call: first(timeOptions).field,
    via_email: false
  };
  const viaEmail = idx(state, _ => _.form[HELP_FORM].values.via_email) || false;
  const canChat = !user.logged_in || user.profile_data.is_client;

  return {
    ...contact,
    initialValues,
    viaEmail,
    canChat,
    formName: HELP_FORM,
  };
}

export function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    onSubmit: (data) => sendContact({ ...data, language: "Chinese" }),
    toggleChat
  }, dispatch);
}

const ContactForm = reduxForm({
  form: HELP_FORM,
  validate,
})(Contact);

export default connect(mapStateToProps, mapDispatchToProps)(ContactForm);



// WEBPACK FOOTER //
// ./marketing/containers/consultation_chinese.jsx